import '../styles/resources.css';
import { Link, useNavigate } from 'react-router-dom';
import { BookOpen, Video, LifeBuoy, Lightbulb } from 'lucide-react';

function Resources() {
    const navigate = useNavigate();

    return (
        <div className="resources-page">
            <section className="container resources-header">
                <h1>Resources to Help You Grow</h1>
                <p>Get the most out of Fleetify with expert guides, video walkthroughs, support articles, and industry tips.</p>
            </section>

            <section className="resources-grid container">
                <div className="resource-card">
                    <BookOpen className="resource-icon" />
                    <h2>Getting Started Guide</h2>
                    <p>Launch your Fleetify account with step-by-step setup help and onboarding tips.</p>
                    <Link to="/sales" className="resource-link">Read Guide →</Link>
                </div>

                <div className="resource-card">
                    <Video className="resource-icon" />
                    <h2>Video Tutorials</h2>
                    <p>Master the platform with short, easy-to-follow walkthroughs on common tasks.</p>
                    <Link to="/sales" className="resource-link">Watch Videos →</Link>
                </div>

                <div className="resource-card">
                    <LifeBuoy className="resource-icon" />
                    <h2>Support Center</h2>
                    <p>Get fast answers from our searchable help articles or reach out to our support team.</p>
                    <Link to="/sales" className="resource-link">Visit Support →</Link>
                </div>

                <div className="resource-card">
                    <Lightbulb className="resource-icon" />
                    <h2>Best Practices</h2>
                    <p>See what leading rental companies are doing to improve efficiency and scale fast.</p>
                    <Link to="/sales" className="resource-link">Explore Tips →</Link>
                </div>
            </section>

            <section className="resources-cta">
                <div className="container">
                    <h2>Still Have Questions?</h2>
                    <p>We’re here to help. Contact us and we’ll walk you through anything you need.</p>
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate('/sales')}
                    >
                        Contact Support
                    </button>
                </div>
            </section>
        </div>
    );
}

export default Resources;
